import axios from "axios";

export const actions = {
    fetchAll({}, { modulesEnabled = null } = { modulesEnabled: null }) {
        return axios.get("/api/modules" + (modulesEnabled ? `?modules=${modulesEnabled.join(",")}` : ""));
    },
};

export default actions;
